<div class="facesheet-section">
  <app-user-select [userList]="userList" (userChange)="onUserChange($event)"></app-user-select>
  <header *ngIf="user$ | async as user">
    <h2 class="user">{{ user.name }}</h2>
    <ng-container *ngIf="formHistoryList && formHistoryList.length > 0">
      <p class="history">
        <span>帳票履歴</span>
        <mat-select class="select-date" [formControl]="form" (selectionChange)="onDateChange()">
          <mat-option *ngFor="let item of formHistoryList" [value]="item.noteid">
            {{ item.sdate | date: "yyyy年MM月dd日 (EEE)" }}　{{ item.subject | truncate:4:'...' }}
          </mat-option>
        </mat-select>
      </p>
    </ng-container>
    <button mat-button class="edit" (click)="dialogAction()" *ngIf="allowEdit">
      編集
      <mat-icon svgIcon="edit"></mat-icon>
    </button>
  </header>
  <div class="facesheet-container" [ngStyle]="titleHeight()" #titleformDiv>
    <ng-container *ngIf="formHistoryList && visible">
      <ng-container *ngIf="formHistoryList.length > 0 && noteTitleParams; else none">
        <lib-note-title [params]="noteTitleParams"></lib-note-title>
      </ng-container>
      <ng-template #none>
        <p class="list-none">表示するデータがありません</p>
      </ng-template>
    </ng-container>
  </div>
</div>
